import cx from "classnames";
import PropTypes from "prop-types";
import { colors } from "theme";
import styled from "styled-components";

const StyledCard = styled.div`
  border-radius: 0.75rem;
  background: #fff;

  &.secondary {
    border: 1px solid rgba(0, 0, 0, 0.1);
  }

  &.selected {
    box-shadow: 0 0 0 3px ${(props) => props["$color"]};
  }
`;

const Card = ({
  selected = false,
  selectable = false,
  selectedColor = undefined,
  secondary = undefined,
  dataTestId = undefined,
  ...props
}) => {
  return (
    <StyledCard
      id={props.id}
      className={cx("card", props.className, {
        selected: selectable && selected,
        secondary,
      })}
      tabIndex={props.tabIndex || (selectable ? 0 : -1)}
      role={props.role || (selectable ? "button" : "region")}
      onClick={props.onClick}
      data-testid={dataTestId}
      $color={colors[selectedColor].default}
    >
      {props.children}
    </StyledCard>
  );
};

Card.defaultProps = {
  tabIndex: 0,
  selectedColor: "neo",
};

Card.propTypes = {
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  role: PropTypes.string,
  id: PropTypes.string,
  selectable: PropTypes.bool,
  tabIndex: PropTypes.number,
  children: PropTypes.any,
  className: PropTypes.string,
  secondary: PropTypes.bool,
  selectedColor: PropTypes.oneOf(Object.keys(colors)),
  dataTestId: PropTypes.string,
};

export default Card;
